/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { EnableSidebar, PageTitle } from '../../../../_metronic/layout/core'
import { Questions } from '../../../modules/apps/dev/components/partials/Questions'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import {KTSVG} from '../../../../_metronic/helpers'
import CookieConsent from 'react-cookie-consent'
import { RecentPublication } from '../dev/components/partials/RecentPublication'
import { useSearchParams } from 'react-router-dom'

const Home: FC = () => {
  const [searchParams, queryParameters] = useSearchParams()
  const [majorID, setMajorID] = useState<string|null>()
  const [majorName, setMajorName] = useState<string|null>()
  const [degreeID, setDegreeID] = useState<string|null>()
  const [degreeName, setDegreeName] = useState<string|null>()
  const [search, setSearch] = useState<string|null>()
  const [personTypeID, setPersonTypeID] = useState<string|null>()
  const [personType, setPersonType] = useState<string|null>()

  useEffect(() => {
    if(searchParams){
      setMajorID(searchParams.get('mid'))
      setMajorName(searchParams.get('major'))
      setDegreeID(searchParams.get('did'))
      setDegreeName(searchParams.get('degree'))
      setSearch(searchParams.get('search'))
      setPersonTypeID(searchParams.get('sid'))
      setPersonType(searchParams.get('staff'))
    }
}, [searchParams]);
  
  

  // const intl = useIntl()
  return (
    <EnableSidebar>
      <PageTitle description='You’ve got 24 New Sales' breadcrumbs={[]}>
        Hello, Paul
      </PageTitle>

      {!majorID && !degreeID && !search && <div className='card card-custom overlay min-h-300px mb-5 shadow-none'>
        <div className='card-body d-flex flex-column p-0'>
          <div
            className='overlay-wrapper flex-grow-1 bgi-no-repeat bgi-size-cover bgi-position-center'
            style={{
              backgroundImage: `url('${toAbsoluteUrl(
                '/media/logos/banner_tu2.png'
              )}')`,
            }}
          />
          {/*<div className='overlay-layer bg-body bg-opacity-50'>
            <a href='#' className='btn btn-sm fw-bold btn-primary'>
              Explore
            </a>
          </div>*/}
        </div>
      </div>}

      {!majorID && !degreeID && !search && <div className='card mb-10'>
        <div className='card-body d-flex align-items-center py-8'>
          {/* begin::Icon */}
          <div className='d-flex h-80px w-80px flex-shrink-0 flex-center position-relative'>
            <KTSVG
              path='/media/icons/duotune/abstract/abs051.svg'
              className='svg-icon-primary position-absolute opacity-15'
              svgClassName='h-80px w-80px'
            />
            <i className="bi bi-question-circle fs-2x"></i>
            {/*<KTSVG
              path='/media/icons/duotune/coding/cod009.svg'
              className='svg-icon-3x svg-icon-primary position-absolute'
            />*/}
          </div>
          {/* end::Icon */}

           {/* begin::Description */}
           <div className='ms-6'>
            <p className='list-unstyled text-gray-600 fs-6 p-0 m-0'>
            คลังปัญญาสถาบัน (Institutional Repository) คณะศิลปศาสตร์ มหาวิทยาลัยธรรมศาสตร์ เป็นคลังความรู้ที่เป็นแหล่งรวบรวม
            เผยแพร่ และสงวนรักษาผลผลิตทางปัญญาของบุคลากรในองค์กรในรูปแบบดิจิทัล เข้าถึงได้แบบเสรี โดยได้รวบรวมความรู้ประเภทต่างๆ 
            ของคณะ เช่น รายงานวิจัย บทความวิจัย บทความวิชาการ เอกสารประกอบการประชุมวิชาการ คลิปการสัมมนาวิชาการ วิทยานิพนธ์ ภาคนิพนธ์ ฯลฯ
            โดยมีวัตถุประสงค์เพื่อเผยแพร่ความรู้ของคณะศิลปศาสตร์แก่นักวิชาการและผู้สนใจทั่วไป ทั้งภายในและภายนอกองค์กรสามารถรับรู้
            เข้าถึงและใช้ประโยชน์ได้อย่างเสรีในระยะยาว และสามารถสืบค้นอ้างอิงได้
            </p>
          </div>
          {/* end::Description */}
        </div>
      </div>}

      <h1 className='fs-2x fw-bolder text-gray-900 mb-5 me-1'>
            {majorName && `ผลการค้นหาใน: "${majorName}"`}
            {degreeName && `ผลการค้นหาใน: "${degreeName}"`}
            {personType && `ผลการค้นหาใน: "${personType}"`}
            {search && `ผลการค้นหา: "${search}"`}
            {!majorName && !degreeName && !search && `รายการล่าสุด`}
      </h1>

      <RecentPublication personType={personTypeID ?  personTypeID : ''} majorID={majorID ? majorID : ''} degreeID={degreeID ? degreeID : ''} search={search ? search : ''} />
      
      <CookieConsent buttonText="ยอมรับ">
        เว็บไซต์นี้มีการใช้งานคุกกี้ จึงขอให้ท่านรับรองว่าท่านได้อ่านและทำความเข้าใจ <a href='https://tu.ac.th/pdpa' target="_blank">นโยบายการใช้งานคุกกี้</a> ซึ่งเป็นส่วนหนึ่งของนโยบายการคุ้มครองข้อมูลส่วนบุคคล
        </CookieConsent>

    </EnableSidebar>
  )
}

export { Home }
